
export function setValue(state, data) {
  state.form[data.field] = data.value
}



